import { registerSW } from 'virtual:pwa-register';

const HOUR = 60 * 60 * 1000;
// OS modals (notification permission, share sheet, file picker) briefly flip
// visibility to hidden and back. Treat anything shorter than this as a modal,
// not a real background, to avoid reloading mid-flow when autoUpdate finds a
// new SW.
const MIN_HIDDEN_MS = 30 * 1000;

export function registerPwaUpdates(): void {
  let hiddenAt: number | null = null;

  registerSW({
    immediate: true,
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      setInterval(() => { void registration.update(); }, HOUR);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          hiddenAt = Date.now();
          return;
        }
        const hiddenFor = hiddenAt ? Date.now() - hiddenAt : Infinity;
        hiddenAt = null;
        if (hiddenFor < MIN_HIDDEN_MS) return;
        void registration.update();
      });
    },
  });
}
